export default {"src":"/_next/static/media/0x45804880de22913dafe09f4980848ece6ecbaf78.cf0b3e8f.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};